export default __webpack_public_path__ + "static/media/plugged_by_driver_card.a4c7f306.svg";